(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-testimonial"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  initSplideSlider();

  // Reinitialize inside theme editor
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.id === 'shopify-section-{{ section.id }}') {
      initSplideSlider();
    }
  });
});

function initSplideSlider() {
  const splideEl = document.querySelector('#testimonial-slider-{{ section.id }} .testimonial-splide');
  if (splideEl && !splideEl.classList.contains('is-initialized')) {
    const splide = new Splide(splideEl, {
      type: 'loop',
      perPage: 1,
      gap: '2rem',
      autoplay: true,
      pauseOnHover: true,
      arrows: true,
      pagination: true,
      breakpoints: {
        750: { perPage: 2 },
        1024: { perPage: 3 }
      }
    });
    splide.mount();
    splideEl.classList.add('is-initialized');
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var $slider = $('.product-slider_container-items');

  if ($slider.length && typeof $slider.slick === 'function') {
    $slider.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: true,
      infinite: true,
      autoplay: false,
      autoplaySpeed: 3000,
      speed: 500,
      arrows: true,
      prevArrow: $('.custom-slick-prev'),
      nextArrow: $('.custom-slick-next'),
      responsive: [
        {
          breakpoint: 1400,
          settings: { slidesToShow: 4 }
        },
        {
          breakpoint: 1024,
          settings: { slidesToShow: 3 }
        },
        {
          breakpoint: 768,
          settings: { slidesToShow: 2 }
        },
        {
          breakpoint: 480,
          settings: { slidesToShow: 2 }
        }
      ]
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
